import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import MasterLayoutTow from '@/layout/MasterLayout.vue'
import { getTokens } from '@/utils/cookieUtils'

// Route definitions
const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    component: MasterLayoutTow,
    children: [
      { path: '', redirect: '/Dashboard' },

      {
        path: 'Dashboard',
        name: 'Dashboard',
        component: () => import('@/views/DashboardView.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'Articles',
        name: 'Articles',
        component: () => import('@/views/ItemView.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'Articles-receptionner',
        name: 'ArticlesReceptionner',
        component: () => import('@/views/ArticlesReceptionnerView.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'Ajouter-article',
        name: 'addArticle',
        component: () => import('@/views/ArticleFormView.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'Modifier-article/:id',
        name: 'updateArticle',
        component: () => import('@/views/ArticleFormView.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'Inventaire-emplacement',
        name: 'InventaireEmplacement',
        component: () => import('@/views/InventoryEmplacementView.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'Inventaire-zone',
        name: 'InventaireZone',
        component: () => import('@/views/InventoryZoneView.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'Inventaire-Location',
        name: 'InventaireLocation',
        component: () => import('@/views/InventoryLocationView.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'Inventaire-departement',
        name: 'InventaireDepartement',
        component: () => import('@/views/InventoryDepartementView.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'Inventaire-detail/:id',
        name: 'InventaireDetail',
        component: () => import('@/views/DetailInventaireView.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'Operations/:id',
        name: 'Operations',
        component: () => import('@/views/OperationsView.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'Tags/historique/:id',
        name: 'Tags',
        component: () => import('@/views/TagHistoryView.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'Article_consomme',
        name: 'Article_consomme',
        component: () => import('@/views/ArticlesCosommeView.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'Article_archive',
        name: 'Article_archive',
        component: () => import('@/views/ArticleArchiveeView.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'Detail/Inventaire/Emplacements/:id',
        name: 'DetailInventaireParEmplacement',
        component: () => import('@/views/DetailInventaireParEmplacmentView.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'Historique/Transfert/:id',
        name: 'Historiquetransfert',
        component: () => import('@/views/HistoriqueTransfertView.vue'),
        meta: { requiresAuth: true }
      }
    ]
  },

  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/LoginView.vue')
  },

  {
    path: '/:catchAll(.*)',
    redirect: '/Dashboard'
  }
]

// Create router
const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  linkActiveClass: 'active',
  linkExactActiveClass: 'exact-active'
})

// Authentication middleware
router.beforeEach((to, from, next) => {
  const isAuthenticated = !!getTokens()
  const requiresAuth = to.matched.some(record => (record.meta as any)?.requiresAuth)

  if (requiresAuth && !isAuthenticated) {
    next({ name: 'Login' })
  } else if (to.name === 'Login' && isAuthenticated) {
    next({ name: 'Dashboard' })
  } else {
    next()
  }
})

export default router

